module.exports = __webpack_public_path__ + "static/media/joyable2_preview.fd98a13b.jpg";